import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { Clickable } from "@/components/toolkit/Clickable";

const MOCK_SEARCH_RESULTS = [
    {
        file: "frontend/components/App.tsx",
        matches: [
            { line: 108, preview: "    const handleKeyDown = (e: KeyboardEvent) => {" },
            { line: 111, preview: '        (e.ctrlKey && e.shiftKey && e.key === "F") ||' },
        ],
    },
    {
        file: "frontend/app_store/state.ts",
        matches: [
            { line: 15, preview: "    isSearchOpen: boolean = false;" },
            { line: 38, preview: "    openSearch() { this.isSearchOpen = true; }" },
        ],
    },
    {
        file: "frontend/components/sections/CodeSection/index.tsx",
        matches: [
            { line: 294, preview: "            {appStore.state.isSearchOpen ? (" },
        ],
    },
];

function highlightMatch(text: string, query: string): React.ReactNode {
    if (!query) return text;
    const idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return text;
    return (
        <>
            {text.slice(0, idx)}
            <mark className="code_section__search_highlight">{text.slice(idx, idx + query.length)}</mark>
            {text.slice(idx + query.length)}
        </>
    );
}

export const SearchPane = observer(({ onClose }: { onClose: () => void }) => {
    const [query, setQuery] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Escape") onClose();
    };

    const hasQuery = query.trim().length > 0;
    const totalMatches = MOCK_SEARCH_RESULTS.reduce((n, f) => n + f.matches.length, 0);

    return (
        <div className="code_section__search_pane">
            <div className="code_section__pane_label">
                <span>SEARCH</span>
                <Clickable onClick={onClose}>
                    <button className="code_section__collapse_btn" title="Close search">×</button>
                </Clickable>
            </div>
            <div className="code_section__search_input_wrap">
                <input
                    ref={inputRef}
                    className="code_section__search_input"
                    placeholder="Search"
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                    spellCheck={false}
                />
            </div>
            {hasQuery && (
                <div className="code_section__search_meta">
                    {totalMatches} result{totalMatches !== 1 ? "s" : ""} in {MOCK_SEARCH_RESULTS.length} file{MOCK_SEARCH_RESULTS.length !== 1 ? "s" : ""}
                </div>
            )}
            <div className="code_section__search_results">
                {!hasQuery && (
                    <div className="code_section__search_hint">Type to search across files</div>
                )}
                {hasQuery && MOCK_SEARCH_RESULTS.map(fileResult => (
                    <div key={fileResult.file} className="code_section__search_file_group">
                        <div className="code_section__search_file_header">
                            <span className="code_section__search_file_icon" />
                            <span className="code_section__search_file_name">{fileResult.file.split("/").pop()}</span>
                            <span className="code_section__search_file_dir">{fileResult.file.split("/").slice(0, -1).join("/")}</span>
                            <span className="code_section__search_match_badge">{fileResult.matches.length}</span>
                        </div>
                        {fileResult.matches.map((match, i) => (
                            <div key={i} className="code_section__search_match_row">
                                <span className="code_section__search_line_num">{match.line}</span>
                                <span className="code_section__search_match_text">
                                    {highlightMatch(match.preview.trim(), query.trim())}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
});
